import * as Sentry from '@sentry/react';

export function logNetworkError(err: any, msg: string, extra?: object) {
  Sentry.captureException(new Error(msg), {
    extra: {
      code: err?.response?.status,
      data: JSON.stringify(err?.response?.data || {}),
      ...(extra || {}),
    },
  });
}
